"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipamentoTipoLabels = exports.EquipamentoTipo = void 0;
var EquipamentoTipo;
(function (EquipamentoTipo) {
    EquipamentoTipo[EquipamentoTipo["TALONARIO_ELETRONICO"] = 0] = "TALONARIO_ELETRONICO";
    EquipamentoTipo[EquipamentoTipo["SEMAFORO"] = 1] = "SEMAFORO";
    EquipamentoTipo[EquipamentoTipo["RADAR_FIXO"] = 2] = "RADAR_FIXO";
    EquipamentoTipo[EquipamentoTipo["RADAR_MOVEL"] = 3] = "RADAR_MOVEL";
    EquipamentoTipo[EquipamentoTipo["GPS"] = 4] = "GPS";
    EquipamentoTipo[EquipamentoTipo["TAXIMETRO"] = 5] = "TAXIMETRO";
    EquipamentoTipo[EquipamentoTipo["IMPRESSORA"] = 6] = "IMPRESSORA";
    EquipamentoTipo[EquipamentoTipo["FISCALIZADOR"] = 7] = "FISCALIZADOR";
    EquipamentoTipo[EquipamentoTipo["TACOGRAFO"] = 8] = "TACOGRAFO";
    EquipamentoTipo[EquipamentoTipo["CAMERA"] = 9] = "CAMERA";
    EquipamentoTipo[EquipamentoTipo["RADAR_ESTATICO"] = 10] = "RADAR_ESTATICO";
    EquipamentoTipo[EquipamentoTipo["NENHUM"] = -1] = "NENHUM";
})(EquipamentoTipo = exports.EquipamentoTipo || (exports.EquipamentoTipo = {}));
exports.EquipamentoTipoLabels = new Map([
    [EquipamentoTipo.TALONARIO_ELETRONICO, 'Talonário Eletrônico'],
    [EquipamentoTipo.SEMAFORO, 'Semáforo'],
    [EquipamentoTipo.RADAR_FIXO, 'Radar Fixo'],
    [EquipamentoTipo.RADAR_MOVEL, 'Radar Móvel'],
    [EquipamentoTipo.GPS, 'GPS'],
    [EquipamentoTipo.TAXIMETRO, 'Taxímetro'],
    [EquipamentoTipo.IMPRESSORA, 'Impressora'],
    [EquipamentoTipo.FISCALIZADOR, 'Fiscalizador'],
    [EquipamentoTipo.TACOGRAFO, 'Tacógrafo'],
    [EquipamentoTipo.CAMERA, 'Câmera'],
    [EquipamentoTipo.RADAR_ESTATICO, 'Radar Estático'],
    [EquipamentoTipo.NENHUM, 'Nenhum Equipamento (Manual)']
]);
